import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "apartment__head-menu" }
const _hoisted_2 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_3 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_4 = { class: "btn-stripped text-danger" }
const _hoisted_5 = { class: "fs-18 text-gray mr-2" }
const _hoisted_6 = { class: "list-bubbles" }
const _hoisted_7 = { class: "bt-icon bt-icon--sm" }
const _hoisted_8 = { class: "apartment__tags" }
const _hoisted_9 = {
  key: 1,
  class: "apartment__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuEPSharing = _resolveComponent("MenuEPSharing")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_ElPopover = _resolveComponent("ElPopover")
  const _component_router_view = _resolveComponent("router-view")
  const _component_DialogPlantCreate = _resolveComponent("DialogPlantCreate")
  const _component_DialogConfirmDeletePlant = _resolveComponent("DialogConfirmDeletePlant")
  const _component_ConfirmPlantUpdated = _resolveComponent("ConfirmPlantUpdated")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("article", {
      class: ["apartment", { 'has--footer': !_ctx.hideFooter }]
    }, [
      (_ctx.currentEntrancePlant)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { onUpdateList: _ctx.fetchPlant }, {
                "head-menu": _withCtx(() => [
                  _createVNode("nav", _hoisted_1, [
                    _createVNode(_component_MenuEPSharing, {
                      usersPermissions: _ctx.usersPermissions,
                      onAddInvitedUser: _ctx.handleInvitedUser,
                      onRemoveSharingUser: _ctx.handleRemoveSharingUser
                    }, null, 8, ["usersPermissions", "onAddInvitedUser", "onRemoveSharingUser"]),
                    _createVNode(_component_Button, {
                      class: "p-button-text p-button-secondary p-1",
                      onClick: _ctx.togglePlantFromFavorites
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InlineSvgScoped, {
                          src: _ctx.favouriteIcon,
                          "aria-label": "icon-favorite-outline"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ElDropdown, {
                      trigger: "click",
                      placement: "bottom-end",
                      "popper-class": "el-dropdown__popper el-dropdown--context"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ElDropdownItem, {
                              onClick: _ctx.toggleEditDialog,
                              disabled: !_ctx.plantEditEnabled
                            }, {
                              default: _withCtx(() => [
                                _createVNode("button", _hoisted_2, [
                                  _createVNode("span", _hoisted_3, [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                        require('@/assets/images/icons/icon-edit.svg')
                                                    ,
                                      "aria-label": "icon-edit"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            _createVNode(_component_ElDropdownItem, {
                              disabled: !_ctx.plantDeleteEnabled,
                              onClick: _ctx.toggleDeletePlantConfirm
                            }, {
                              default: _withCtx(() => [
                                _createVNode("button", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                        require('@/assets/images/icons/icon-ellipsis-v.svg')
                                    ,
                              "aria-label": "icon-ellipsis-v"
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                "update-time-meta": _withCtx(() => [
                  _createVNode("time", _hoisted_5, _toDisplayString(_ctx.$t("general.modified")) + ": " + _toDisplayString(_ctx.getParsedDate(_ctx.currentEntrancePlant?.lastModify)), 1),
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_ElPopover, {
                      placement: "top",
                      trigger: "hover",
                      title: _ctx.username,
                      "popper-class": "el-popover--dark el-popover--slim"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_Button, {
                          disabled: "",
                          class: "p-button-rounded p-button-sm p-button-secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userInitials), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createVNode(_component_ElPopover, {
                      placement: "top",
                      trigger: "hover",
                      title: _ctx.iconDeviceLabel,
                      "popper-class": "el-popover--dark el-popover--slim"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_Button, {
                          disabled: "",
                          class: "p-button-rounded p-button-icon-only p-button-sm p-button-secondary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("span", _hoisted_7, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: 
                                                require(`@/assets/images/icons/${_ctx.iconDevice}.svg`)
                                            ,
                                "aria-label": _ctx.iconDevice
                              }, null, 8, ["src", "aria-label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ]),
                  _createVNode("ul", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.tags, (tag, index) => {
                      return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(tag.value), 1))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["onUpdateList"]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.hideFooter)
        ? (_openBlock(), _createBlock("footer", _hoisted_9, [
            _createVNode(_component_Button, {
              class: "p-button-rounded p-button-raised p-button--m",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSaveAndExitClick()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Exit")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_DialogPlantCreate, {
      editPlantId: _ctx.selectedPlantId,
      editPlantType: _ctx.PlantType.ENTRANCE_PLANT,
      isEdit: true,
      onPlantEdited: _ctx.fetchPlant,
      onHideDialog: _ctx.toggleEditDialog,
      "is-visible": _ctx.isVisibleEditDialog
    }, null, 8, ["editPlantId", "editPlantType", "onPlantEdited", "onHideDialog", "is-visible"]),
    _createVNode(_component_DialogConfirmDeletePlant, {
      "plant-name": _ctx.plantName,
      onConfirm: _ctx.handleDeletePlant,
      onHideDialog: _ctx.toggleDeletePlantConfirm,
      "is-visible": _ctx.isVisibleDeletePlantConfirm
    }, null, 8, ["plant-name", "onConfirm", "onHideDialog", "is-visible"]),
    _createVNode(_component_ConfirmPlantUpdated, {
      onHideDialog: _ctx.hideConfirmPlantUpdated,
      "is-visible": _ctx.isVisibleConfirmPlantUpdated
    }, null, 8, ["onHideDialog", "is-visible"])
  ], 64))
}